import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

import { PopBaseComponent } from '../../../base/pop-base-component';
import { Constants } from './product-center-search-worker-tester.constants';
import { productCenterSearchMock } from './product-center-search-worker-tester.mock';
import {
  Product,
  type ProductCenterExhibit,
} from '../../product-center-table-wrapper/product-center-table-wrapper.model';
import productCenterStore, {
  zustandStateToComponent,
} from '../../store/product-center.store';
import type { IProductCenterStore } from '../../store/product-center.store.model';

/**
 * @tag pop-pc-search-worker-tester-component
 * @summary Represents a component to search product data
 * @property {SearchComponent} [componentObject] SearchComponent object
 * @attribute {SearchComponent} [data-component-object] SearchComponent object
 */
@customElement(Constants.TAG_NAME)
export class PopProductCenterSearchWorkerTesterComponent extends PopBaseComponent {
  static readonly tagName = Constants.TAG_NAME;

  /**
   * @internal
   */
  @state()
  productCenterState: IProductCenterStore = productCenterStore.getState();

  /*
   * @internal
   */
  @property()
  private readonly originalProductCenterObject: ProductCenterExhibit = {
    products: productCenterSearchMock.products,
    disclaimers: [],
  };

  /*
   * @internal
   */
  @property()
  private filteredProducts: Product[] = [];

  firstUpdated() {
    this.productCenterState.setOriginalProductCenterObject(
      this.originalProductCenterObject,
    );
    this.filteredProducts = this.productCenterState.getFilteredProducts();
  }

  update(changedProperties: Map<string, unknown>) {
    if (changedProperties.has('componentObject')) {
      this.filteredProducts =
        (this.componentObject as ProductCenterExhibit).products ?? [];
    }
    super.update(changedProperties);
  }

  renderTableHead() {
    return html`
      <thead>
        <tr>
          ${Constants.SEARCH_KEYS.map(
            (key) =>
              html`<th
                style="padding:1rem 2rem 1rem 0;"
                scope="col"
                headers="${key['name']}"
              >
                ${key['name']}
              </th>`,
          )}
        </tr>
      </thead>
    `;
  }

  renderTableBody() {
    return html`
      <tbody>
        ${this.filteredProducts.map((fund) => this.renderTableRow(fund))}
      </tbody>
    `;
  }

  renderTableRow(fund: Product) {
    return html`
      <tr>
        <td>${fund.productCode}</td>
        <td>${fund.productName.apir}</td>
        <td>${fund.productName.shareClass}</td>
        <td>${fund.productName.baseCurrencyName}</td>
        <td>${fund.productName.fundName}</td>
        <td>${fund.productName.vehicleTypeName}</td>
        <td>${fund.productName.sfdrClassification}</td>
        <td>${fund.productName.investmentStrategiesAssetClassName}</td>
        <td>${fund.productName.investmentStrategiesRegionName}</td>
        <td>${fund.performance?.morningstarMedalistRating}</td>
      </tr>
    `;
  }

  renderSearchBar() {
    return html` <pop-pc-search-bar></pop-pc-search-bar> `;
  }

  render() {
    return html`
      <div id="beacon-root">
        <form
          novalidate=""
          id="form-validate"
          style="--div-padding: 0; padding: 16px;"
          class="demo"
        >
          ${this.renderSearchBar()}
          <beacon-button label="Search" scale="mini"></beacon-button>
        </form>
        <table>
          ${this.renderTableHead()} ${this.renderTableBody()}
        </table>
      </div>
    `;
  }
}

export const productCenterTableWrapperMapState = (productCenterState) => {
  return {
    // originalProductCenterObject: productCenterState.originalProductCenterObject,
    filteredProducts: productCenterState.getFilteredProducts(),
  };
};

if (!customElements.get(Constants.TAG_NAME)) {
  customElements.define(
    Constants.TAG_NAME,
    zustandStateToComponent(
      {
        mapState: (productCenterState) => {
          return {
            ...productCenterTableWrapperMapState(productCenterState),
          };
        },
      },
      PopProductCenterSearchWorkerTesterComponent,
    ),
  );
}
